/* Forged Racing — country picker behavior: open/close, search filter,
   keyboard navigation, focus containment. */
(function () {
  'use strict';

  function init(cp) {
    if (cp.dataset.forgedInit) return;
    cp.dataset.forgedInit = 'true';

    var trigger = cp.querySelector('.forged-cp__trigger');
    var panel = cp.querySelector('.forged-cp__panel');
    var search = cp.querySelector('.forged-cp__search');
    var empty = cp.querySelector('.forged-cp__empty');
    if (!trigger || !panel || !search) return;

    function items() {
      return Array.prototype.slice.call(panel.querySelectorAll('.forged-cp__item:not([hidden])'));
    }

    function open() {
      panel.hidden = false;
      cp.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (window.ForgedFlag) window.ForgedFlag.hydrate(panel);
      search.value = '';
      filter('');
      search.focus();
    }

    function close(refocus) {
      cp.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      clearHighlight();
      // let the close transition play before display: none
      setTimeout(function () {
        if (!cp.classList.contains('is-open')) panel.hidden = true;
      }, 200);
      if (refocus) trigger.focus();
    }

    function filter(term) {
      var q = term.trim().toLowerCase();
      var any = false;
      panel.querySelectorAll('.forged-cp__item').forEach(function (item) {
        var match = !q || item.dataset.search.indexOf(q) !== -1;
        item.hidden = !match;
        if (match) any = true;
      });
      if (empty) empty.hidden = any;
      clearHighlight();
    }

    var highlighted = -1;

    function clearHighlight() {
      highlighted = -1;
      panel.querySelectorAll('.is-highlighted').forEach(function (el) {
        el.classList.remove('is-highlighted');
      });
    }

    function highlight(index) {
      var visible = items();
      if (!visible.length) return;
      highlighted = (index + visible.length) % visible.length;
      visible.forEach(function (el, i) {
        el.classList.toggle('is-highlighted', i === highlighted);
      });
      visible[highlighted].scrollIntoView({ block: 'nearest' });
    }

    trigger.addEventListener('click', function () {
      if (cp.classList.contains('is-open')) {
        close(true);
      } else {
        open();
      }
    });

    search.addEventListener('input', function () {
      filter(search.value);
    });

    cp.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close(true);
        return;
      }
      if (panel.hidden) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        highlight(highlighted + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(highlighted - 1);
      } else if (event.key === 'Enter' && highlighted > -1) {
        event.preventDefault();
        var visible = items();
        if (visible[highlighted]) visible[highlighted].querySelector('.forged-cp__option').click();
      } else if (event.key === 'Tab') {
        // contain focus within the open panel
        var focusables = [search].concat(
          items().map(function (item) {
            return item.querySelector('.forged-cp__option');
          })
        );
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    document.addEventListener('click', function (event) {
      if (cp.classList.contains('is-open') && !cp.contains(event.target)) close(false);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
